import { Checkbox, FormControlLabel, Alert, Stack, Typography, useMediaQuery } from '@mui/material'
import { FC, useContext } from 'react'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import { StepContentRendererProps } from '~/features/campaign_create/ExpenseInfo/Steps'
import { CommonStepContent } from '~/features/campaign_create/ExpenseInfo/StepContents/CommonStepContent'
import { LinkToInfo } from '~/components/common/LinkToInfo'
import { CampaignCategory } from '~/generated/graphql'
import { theme } from '~/lib/theme'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'

export const ExpenseEvidenceTypeStep: FC<StepContentRendererProps> = ({ shouldHideDialog, setShouldHideDialog }) => {
  const { campaign } = useContext(CreateCampaignContext)
  const isService = campaign.category === CampaignCategory.Service
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const messages = isService
    ? [
        'インフルエンサーは、立替金額の精算申請時に「領収書」を支払い証憑として添付します。',
        '申請内容と領収書をご確認いただき、立替精算の承認をお願いします。',
      ]
    : [
        'インフルエンサーが実際に立替えしたという証憑の形式を予め設定することができます。',
        '「領収書」もしくは「注文番号（注文を特定することができる番号）」の設定が可能です。',
        '精算申請を確認する際にご自身が内容確認をしやすい方を選択してください。',
        '精算時は申請内容と証憑をご確認いただき、立替精算の承認をお願いします。',
      ]

  return (
    <CommonStepContent>
      <Alert severity="info" sx={{ mb: 2 }} icon={isMobile ? false : undefined}>
        <Stack gap={0.5}>
          {messages.map((line, index) => (
            <Typography key={index} variant="body2">
              {line}
              <br />
            </Typography>
          ))}
          <LinkToInfo
            textBefore="承認画面については"
            href={EXTERNAL_LINKS.EXPENSE_AFTER_PUBLISH_FAQ}
            textAfter="をご確認ください。"
          />
        </Stack>
      </Alert>
      <FormControlLabel
        control={<Checkbox checked={shouldHideDialog} onChange={(e) => setShouldHideDialog(e.target.checked)} />}
        label="今後このメッセージを表示しない"
      />
    </CommonStepContent>
  )
}
